import React, { useEffect, useState } from 'react';
import { canchaService } from '../../services/canchaService';
import CanchaForm from './CanchaForm';

export default function CanchaList() {
  const [canchas, setCanchas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editCancha, setEditCancha] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    fetchCanchas();
  }, []);

  const fetchCanchas = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await canchaService.getMisCanchas();
      setCanchas(response.data);
    } catch (err) {
      setError('Error al cargar las canchas');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = cancha => {
    setEditCancha(cancha);
    setShowEditModal(true);
  };

  const handleDelete = async id => {
    if (!window.confirm('¿Seguro que deseas eliminar esta cancha?')) return;
    try {
      await canchaService.eliminarCancha(id);
      fetchCanchas();
    } catch (err) {
      alert('Error al eliminar la cancha');
    }
  };

  const handleUpdate = async (data) => {
    try {
      await canchaService.actualizarCancha(editCancha.id, data);
      setShowEditModal(false);
      setEditCancha(null);
      fetchCanchas();
    } catch (err) {
      alert('Error al actualizar la cancha');
    }
  };

  if (loading) return <div>Cargando canchas...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="bg-white rounded shadow p-4 mt-6">
      <h2 className="text-xl font-bold mb-4">Mis Canchas</h2>
      {canchas.length === 0 ? (
        <div>No hay canchas registradas.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {canchas.map(cancha => (
            <div key={cancha.id} className="border rounded p-3 relative">
              <h3 className="font-semibold text-lg mb-1">{cancha.nombre}</h3>
              <p><strong>Tipo:</strong> {cancha.tipo}</p>
              <p><strong>Precio/hora:</strong> S/ {cancha.precio_por_hora}</p>
              <p><strong>Descripción:</strong> {cancha.descripcion}</p>
              {cancha.imagenes && cancha.imagenes.length > 0 && (
                <div className="flex flex-wrap mt-2">
                  {cancha.imagenes.map((img, i) => (
                    <img key={i} src={img} alt="cancha" className="h-16 w-16 object-cover rounded mr-2 mb-2" />
                  ))}
                </div>
              )}
              <div className="flex gap-2 mt-3">
                <button className="bg-yellow-500 text-white px-3 py-1 rounded text-sm" onClick={() => handleEdit(cancha)}>Editar</button>
                <button className="bg-red-600 text-white px-3 py-1 rounded text-sm" onClick={() => handleDelete(cancha.id)}>Eliminar</button>
              </div>
            </div>
          ))}
        </div>
      )}
      {/* Modal de edición */}
      {showEditModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto relative">
            <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl" onClick={() => setShowEditModal(false)}>&times;</button>
            <CanchaForm
              onCreated={handleUpdate}
              initialData={editCancha}
            />
          </div>
        </div>
      )}
    </div>
  );
}
